<template>
  <common-query :query="query" @query="onClickQuery">
    <el-form-item label="档案号">
      <el-input v-model="query.merId" placeholder="请输入" />
    </el-form-item>
    <el-form-item label="商户名称">
      <el-input v-model="query.merName" placeholder="请输入" />
    </el-form-item>
    <el-form-item label="法人名字">
      <el-input v-model="query.corpName" placeholder="请输入" />
    </el-form-item>
    <el-form-item label="联系电话">
      <el-input v-model="query.corpPhone" placeholder="请输入" />
    </el-form-item>
    <el-form-item label="城市服务商">
      <common-select v-model="query.serviceId" filterable :list="services" />
    </el-form-item>
    <el-form-item label="收单机构">
      <common-select v-model="query.companyId" :list="companys" />
    </el-form-item>
    <el-form-item label="渠道">
      <common-select v-model="query.bankCode" :list="channels" />
    </el-form-item>
    <el-form-item label="发行类型">
      <common-select v-model="query.stateAudit" :list="issuanceType" />
    </el-form-item>
    <el-form-item label="拓展人员">
      <!-- <common-select v-model="query.expandUserId" :list="expandUserList" /> -->
      <el-input v-model="query.expandUserName" placeholder="请输入"></el-input>
    </el-form-item>
    <el-form-item label="核准时间" class="auto-width">
      <date-picker v-model="query.bankBeginTime" />
      <span class="middle-text">至</span>
      <date-picker v-model="query.bankEndTime" />
    </el-form-item>
  </common-query>
</template>

<script>
export default {
  props: {
    query: {
      type: Object,
      comment: '请求的数据'
    },
    services: {
      type: Array,
      default() {
        return []
      }
    },
    channels: {
      type: Array,
      default() {
        return []
      }
    },
    companys: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data() {
    return {
      issuanceType: [
        { value: '', label: '全部' },
        { value: 7, label: '有额度通过' },
        { value: 16, label: '无额度通过' }
      ]
    }
  },

  methods: {
    onClickQuery() {
      this.$emit('query', this.query)
    }
  }
}
</script>
